import {ProcessedClauseChange} from "common/flowmaster/types/amendment";
import actionTypes, {AmendmentsActionTypes} from "../constants/action_types";

export type AddAmendmentClauseChangesAction = {
  type: AmendmentsActionTypes["AMENDMENT_CLAUSE_CHANGES_ADD"]["SUCCESS"];
  payload: ProcessedClauseChange[];
};

export default function addAmendmentClauseChanges(
  clauseChanges: ProcessedClauseChange[],
) {
  return {
    type: actionTypes.AMENDMENT_CLAUSE_CHANGES_ADD.SUCCESS,
    payload: clauseChanges,
  };
}
